export default __webpack_public_path__ + "static/media/overview.af257717.svg";